export function getBrandSlug(brandName) {
  const brandSlug = `/${brandName.replace(/\s/g, '').toLowerCase()}`;

  if (brandName === 'portal') {
    return '';
  }

  if (brandName.includes('Floortje') || brandName.includes('floortje')) {
    return '/floortje';
  }

  return brandSlug;
}
